import { RestaurantEvent } from './types';
import { getDispatch } from '../../../store/dispatchAccessor';
import { api } from '../../../store/commonApi';

export type OrderCreatedType = RestaurantEvent & {
	type: 'ORDER_CREATED';
	orderId: string;
	tableSessionId: string;
	restaurantId: string;
};

export function handleNewOrderCreated(/* e: OrderCreatedType */): void {
	const dispatch = getDispatch();

	dispatch(api.util.invalidateTags([{ type: 'Order', id: 'LIST' }]));
}
